import { TaskEasy } from "./TaskEasy.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  TaskEasy
};
//# sourceMappingURL=index.js.map
